var _path, _path2, _path3, _circle, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcClockLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 29,
    viewBox: "0 0 50 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9972 13.6232C44.9967 9.91772 42.0927 6.77757 38.5546 4.49414L33.1328 12.8951C37.2641 15.5667 39.9982 20.2141 39.9982 25.5C39.9982 25.538 39.9981 25.576 39.9978 25.614L49.9975 25.6903C50.0296 21.4795 48.9976 17.3287 46.9972 13.6232Z",
    fill: "url(#paint0_linear_13002_31010)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2281 0.501071C21.0173 0.462094 16.8649 1.48738 13.1562 3.48179L17.8909 12.2862C20.0057 11.1467 22.4254 10.5 24.9961 10.5C27.6663 10.5 30.1736 11.1977 32.3456 12.4208L37.2429 3.70475C33.5717 1.64203 29.4389 0.540048 25.2281 0.501071Z",
    fill: "url(#paint1_linear_13002_31010)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09233 13.457C1.06368 17.1471 0 21.2898 0 25.5008H10C10 25.5005 10 25.5003 10 25.5C10 20.1733 12.7765 15.4951 16.9612 12.8337L11.6043 4.39258C8.04889 6.64893 5.12099 9.76682 3.09233 13.457Z",
    fill: "url(#paint2_linear_13002_31010)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.5,
    r: 3,
    fill: "#0D1A16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9919 19.2359L25.1571 27.9157L27.1408 24.4423L13.9919 19.2359Z",
    fill: "#0D1A16"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13002_31010",
    x1: -2.37226,
    y1: 20.755,
    x2: 57.1168,
    y2: 20.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331417,
    stopColor: "#FFED4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578505,
    stopColor: "#FF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13002_31010",
    x1: -2.37551,
    y1: 20.7555,
    x2: 57.1136,
    y2: 20.0255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331417,
    stopColor: "#FFED4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578505,
    stopColor: "#FF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13002_31010",
    x1: -2.37226,
    y1: 20.7563,
    x2: 57.1168,
    y2: 20.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECB81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331417,
    stopColor: "#FFED4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578505,
    stopColor: "#FF922D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3535"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockLight);
export default __webpack_public_path__ + "static/media/ic_clockLight.58b04f49ed75993fd484787aeaa97e45.svg";
export { ForwardRef as ReactComponent };